import { HTTP_TO_MANY_REQUESTS } from '../framework/constants/app';
export const CF_CHALLENGE_REDIRECT_KEY = 'cf_challenge_redirect_attempted';
// Longer than the rate-limit window (20s) plus a slow interactive challenge, so a repeat failure
// right after coming back from the challenge is never answered with a second redirect.
export const CF_CHALLENGE_REDIRECT_COOLDOWN_MS = 2 * 60 * 1000;
// The only rate-limit rule that answers with a solvable challenge (Search List). Its car-search-endpoint
// handler 307s a filter-less GET back to the `url` query param, which is what lets the user land on
// their own search after solving it. Any other 429 must not be redirected to an API path.
const CHALLENGED_SEARCH_PATH = '/service/car-search-endpoint/api/v1/search/car/formatted';
/**
 * Allows a challenge redirect at most once per cooldown per tab. Deliberately NOT cleared by
 * successful responses: a page such as the homepage fires many requests that succeed while the
 * search request keeps being challenged, and resetting on success turned the guard into an
 * infinite reload loop. If sessionStorage is unusable the guard cannot be kept, so it refuses.
 */
export const claimChallengeRedirect = (now = Date.now()) => {
    try {
        const last = Number(sessionStorage.getItem(CF_CHALLENGE_REDIRECT_KEY));
        if (last && now - last < CF_CHALLENGE_REDIRECT_COOLDOWN_MS)
            return false;
        sessionStorage.setItem(CF_CHALLENGE_REDIRECT_KEY, String(now));
        return true;
    }
    catch (e) {
        return false;
    }
};
/**
 * Value to append to the fe-main redirectUrl= endpoint, or null when no redirect should happen.
 *  - 503 / WAF challenge (403): the current route is covered by the rule too, so reload it.
 *  - 429 challenge: only navigating to the rate-limited API path shows the interstitial, and only
 *    the search path is known to bounce back to a real page afterwards.
 * Always a relative path: nginx merge_slashes collapses the "//" of an absolute URL.
 */
export const getChallengeRedirectTarget = (status, responseURL, location) => {
    if (status !== HTTP_TO_MANY_REQUESTS) {
        return `${location.pathname}${encodeURIComponent(location.search)}`;
    }
    let apiPath;
    try {
        apiPath = new URL(responseURL).pathname;
    }
    catch (e) {
        return null;
    }
    if (apiPath !== CHALLENGED_SEARCH_PATH)
        return null;
    // The endpoint runs decodeURI() on `url` after Express already decoded it once, so escapes
    // already present in the page URL (%20, %C3%BC...) are doubled to survive that second pass.
    const pageUrl = `${location.pathname}${location.search}`.replace(/%/g, '%25');
    return encodeURIComponent(`${apiPath}?url=${encodeURIComponent(pageUrl)}`);
};
